import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CSpinner,
  CLabel
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import {
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  FormGroup
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import Loading from "../../../components/Loading";
import QuestionModal from "../../../components/PedagogicalFollowUps/QuestionModal";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";

class PedagogicalFollowUpsCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      edit: false,
      name: "",
      disciplineId: "",
      disciplinesList: [],
      serieId: null,
      serieList: [],
      creating: false,
      // Estados para lista de questões
      questionsListLoading: false,
      availableQuestionsList: [],
      selectedQuestions: [],
      showQuestionModal: false,
      // Estados para PDF
      pdfFile: null,
      existingPdfUrl: null,
      pdfOriginalName: "",
      contentList: [], // ← adicionar
      modalProps: {
        // ← adicionar
        modalCompoent: 1,
        type: null,
        typeName: "",
        title: ""
      },
      modal: false, // ← adicionar
      newList: false, // ← adicionar
      editing: false, // ← adicionar (cuidado: você já tem `edit`)
      editListId: null // ← adicionar
    };

    this.error = this.error.bind(this);
    this.pdfInputRef = React.createRef();
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    const { id } = this.props.match.params;

    // Carregar disciplinas e séries
    axios
      .all([
        axios.get(`${URL.api}classification/discipline/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(`${URL.api}classification/serie/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread((respDiscipline, respSeries) => {
          const disciplinesList = respDiscipline.data.data.map(discipline => ({
            id: discipline.id,
            name: discipline.name
          }));

          this.setState({
            disciplinesList,
            serieList: respSeries.data.data
          });
        }),
        error => {
          this.error(error.response.statusText);
        }
      );

    // Se tem ID, está em modo de edição
    if (id) {
      this.setState({ edit: true });

      axios
        .get(`${URL.api}pedagogical/follow-ups/${id}/show`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(respFollowUp => {
          if (respFollowUp.data.success) {
            const followUpData = respFollowUp.data.data;

            const normalizedQuestions = (
              followUpData.selected_questions || []
            ).map(item => this.normalizeQuestionItem(item));

            this.setState(
              {
                loading: false,
                name: followUpData.name,
                disciplineId: followUpData.discipline_id,
                serieId: followUpData.serie_id,
                selectedQuestions: normalizedQuestions,
                existingPdfUrl: followUpData.pdf_url || null,
                pdfOriginalName: followUpData.pdf_original_name || ""
              },
              () => {
                this.loadAvailableQuestionsList();
              }
            );
          } else {
            toastr.error("Erro", "Acompanhamento pedagógico não encontrado");
            this.props.history.push("/pedagogical-follow-ups/list");
          }
        })
        .catch(error => {
          toastr.error("Erro", "Erro ao carregar acompanhamento pedagógico");
          this.props.history.push("/pedagogical-follow-ups/list");
        });
    } else {
      this.setState({ loading: false });
      this.loadAvailableQuestionsList();
    }
  }

  changeName = e => {
    this.setState({
      name: e.target.value
    });
  };

  changeDiscipline = e => {
    this.setState({
      disciplineId: e.target.value
    });
  };

  changeSerie = e => {
    this.setState({
      serieId: e.target.value
    });
  };

  // Handlers para PDF
  handlePdfChange = e => {
    const file = e.target.files[0];
    if (!file) {
      this.setState({ pdfFile: null });
      return;
    }

    // Validações
    if (file.type !== "application/pdf") {
      toastr.error("Erro", "Apenas arquivos PDF são permitidos.");
      this.setState({ pdfFile: null });
      if (this.pdfInputRef.current) this.pdfInputRef.current.value = "";
      return;
    }

    const maxSize = 20 * 1024 * 1024; // 20MB
    if (file.size > maxSize) {
      toastr.error("Erro", "O arquivo PDF não pode exceder 20MB.");
      this.setState({ pdfFile: null });
      if (this.pdfInputRef.current) this.pdfInputRef.current.value = "";
      return;
    }

    this.setState({
      pdfFile: file,
      pdfOriginalName: file.name
    });
  };

  removePdf = () => {
    this.setState({
      pdfFile: null,
      existingPdfUrl: null,
      pdfOriginalName: ""
    });
    if (this.pdfInputRef.current) this.pdfInputRef.current.value = "";
  };

  normalizeQuestionItem = item => {
    let desc = item.description || item.item_description || "";
    if (item.ability_code) {
      const abilityText =
        item.ability_description || item.ability || item.description || "";
      desc = `${item.ability_code} - ${abilityText}`;
    } else if (item.ability_description && !desc) {
      desc = item.ability_description;
    }

    return {
      id: item.id || item.item_id,
      item_id: item.item_id,
      description: desc,
      ability_description: item.ability_description || null,
      ability_code: item.ability_code || null,
      thematic_unit_name: item.thematic_unit_name || null,
      options: (item.options || []).map(opt => ({
        items_options_id: opt.items_options_id,
        id: opt.id,
        title: opt.title,
        description: opt.description,
        type: opt.type
      }))
    };
  };

  loadAvailableQuestionsList = () => {
    this.setState({ questionsListLoading: true });

    axios
      .get(`${URL.api}pedagogical/follow-ups/items-options/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(response => {
        const grouped = response.data.data || [];

        const mapped = grouped.map(item => this.normalizeQuestionItem(item));

        const filteredList = mapped.filter(
          item =>
            !this.state.selectedQuestions.find(
              q => (q.item_id || q.id) === (item.item_id || item.id)
            )
        );

        this.setState({
          availableQuestionsList: filteredList,
          questionsListLoading: false
        });
      })
      .catch(error => {
        console.error("Erro ao carregar listas de questões:", error);
        this.setState({
          questionsListLoading: false,
          availableQuestionsList: []
        });
      });
  };

  addQuestionToList = questionList => {
    const { selectedQuestions, availableQuestionsList } = this.state;

    if (
      selectedQuestions.find(
        q => (q.item_id || q.id) === (questionList.item_id || questionList.id)
      )
    ) {
      toastr.warning("Aviso", "Esta questão já foi adicionada");
      return;
    }

    this.setState({
      selectedQuestions: [...selectedQuestions, questionList],
      availableQuestionsList: availableQuestionsList.filter(
        q => (q.item_id || q.id) !== (questionList.item_id || questionList.id)
      )
    });
  };

  removeQuestionFromList = questionListId => {
    const { selectedQuestions, availableQuestionsList } = this.state;

    const removedQuestion = selectedQuestions.find(
      q => (q.item_id || q.id) === questionListId
    );

    if (!removedQuestion) {
      return;
    }

    const alreadyInAvailable = availableQuestionsList.find(
      q => (q.item_id || q.id) === questionListId
    );

    const updatedAvailableList = !alreadyInAvailable
      ? [...availableQuestionsList, removedQuestion]
      : availableQuestionsList;

    this.setState({
      selectedQuestions: selectedQuestions.filter(
        q => (q.item_id || q.id) !== questionListId
      ),
      availableQuestionsList: updatedAvailableList
    });
  };

  // Modal handlers
  openQuestionModal = () => {
    this.setState({ showQuestionModal: true });
  };

  closeQuestionModal = () => {
    this.setState({ showQuestionModal: false });
  };

  handleQuestionCreated = () => {
    this.loadAvailableQuestionsList();
  };

  selectedItem = item => {
    if (item.id <= 12) {
      this.setState(
        prevState => ({
          modalProps: {
            ...prevState.modalProps,
            modalCompoent: 1,
            type: item.id,
            typeName: item.name,
            title: `Selecione - ${item.name}`
          }
        }),
        () => {
          this.toggleModal();
        }
      );
    } else if (item.id === 17) {
      this.setState(
        prevState => ({
          modalProps: {
            ...prevState.modalProps,
            modalCompoent: 1,
            type: item.id,
            typeName: item.name,
            title: `Selecione - ${item.name}`
          }
        }),
        () => {
          this.toggleModal();
        }
      );
    }
  };

  selectedListItem = list => {
    let { id, name } = list;
    let contentList = [];

    if (this.state.editing) {
      let checkEdit = false;
      this.state.contentList.forEach(content => {
        if (content.type === 12) {
          checkEdit = true;
          content.list.id = id;
          content.list.name = name;
        }
        contentList.push(content);
      });

      if (!checkEdit) {
        let obj = {
          type: 12,
          list: {
            id,
            name
          }
        };

        contentList.push(obj);
      }
    } else {
      this.state.contentList.forEach(list => {
        contentList.push(list);
      });

      let check = true;
      if (contentList.length > 0) {
        check = false;
        toastr.error(
          "Erro",
          "Você só pode adicionar uma lista. Caso deseje trocar, exclua a lista já adicionada."
        );
      }

      let obj = {
        type: 12,
        list: {
          id,
          name
        }
      };

      if (check) {
        contentList.push(obj);
      }
    }

    this.setState(
      {
        contentList,
        editListId: null
      },
      () => {
        this.toggleModal();
      }
    );
  };

  removeItem = (type, id) => {
    let contentList = [];
    this.state.contentList.forEach(item => {
      if (item.type !== type || item.list.id !== id) {
        contentList.push(item);
      }
    });

    this.setState({
      contentList
    });
  };

  toggleModal = () => {
    this.setState(state => ({
      modal: !state.modal,
      newList: state.modal ? false : state.newList,
      editing: state.modal ? false : state.editing
    }));
  };

  getContent = content => {
    let contentList = [];
    this.state.contentList.forEach(list => {
      contentList.push(list);
    });

    for (let i = 0; i < content.list.length; i++) {
      let check = true;
      let obj = {
        type: content.type,
        list: content.list[i]
      };

      for (let j = 0; j < contentList.length; j++) {
        if (
          content.type === contentList[j].type &&
          content.list[i].id === contentList[j].list.id
        ) {
          check = false;
          toastr.error(
            "Erro",
            `O conteúdo "${content.list[i].name}" já tinha sido adicionado antes.`
          );
          break;
        }
      }

      if (check) {
        contentList.push(obj);
      }
    }

    this.setState(
      {
        contentList
      },
      () => {
        this.toggleModal();
      }
    );
  };

  saveActivity = () => {
    let emptyField = true;
    let obj = {
      name: this.state.name,
      discipline_id: this.state.disciplineId.toString(),
      serie_id: this.state.serieId.toString()
    };

    if (obj.name === "") {
      toastr.error("Erro", "Campo nome é obrigatório");
      emptyField = false;
    }

    if (obj.discipline_id === "" || obj.discipline_id === "0") {
      toastr.error("Erro", "Campo disciplina é obrigatório");
      emptyField = false;
    }

    if (obj.serie_id === "" || obj.serie_id === "0") {
      toastr.error("Erro", "Campo série é obrigatório");
      emptyField = false;
    }

    if (emptyField) {
      this.setState({ creating: true });

      if (this.state.edit) {
        this.editActivity(obj);
      } else {
        this.createActivity(obj);
      }
    }
  };

  // Monta o FormData para envio (tanto criação quanto edição)
  buildFormData(baseObj) {
    const formData = new FormData();

    // Adiciona campos básicos
    formData.append("name", baseObj.name);
    formData.append("discipline_id", baseObj.discipline_id);
    formData.append("serie_id", baseObj.serie_id);

    // Adiciona questões selecionadas (formato esperado pelo backend)
    const selectedQuestionsFlat = [];
    this.state.selectedQuestions.forEach(q => {
      if (q.options && q.options.length > 0) {
        q.options.forEach(option => {
          if (option.items_options_id) {
            selectedQuestionsFlat.push({
              items_options_id: option.items_options_id
            });
          }
        });
      } else {
        selectedQuestionsFlat.push({
          items_options_id: q.id
        });
      }
    });

    // Envia como array de objetos – precisa ser enviado como JSON string ou como campos indexados?
    // O backend espera 'selected_questions' como um array de objetos com 'items_options_id'.
    // Com FormData, deve-se enviar como string JSON.
    formData.append(
      "selected_questions",
      JSON.stringify(selectedQuestionsFlat)
    );

    // Adiciona PDF se existir
    if (this.state.pdfFile) {
      formData.append("pdf", this.state.pdfFile);
    }

    return formData;
  }

  createActivity = obj => {
    const formData = this.buildFormData(obj);

    axios
      .post(`${URL.api}pedagogical/follow-ups/create`, formData, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Content-Type": "multipart/form-data"
        }
      })
      .then(
        resp => {
          if (resp.data.success) {
            toastr.success("Sucesso", resp.data.message);
            this.props.history.push(`/pedagogical-follow-ups/list`);
          } else {
            toastr.error(
              "Erro",
              resp.data.message || "Erro ao criar acompanhamento"
            );
            this.setState({ creating: false });
          }
        },
        error => {
          const errorMessage =
            error.response?.data?.message ||
            "Erro ao criar acompanhamento pedagógico";
          toastr.error("Erro", errorMessage);
          this.setState({ creating: false });
        }
      );
  };

  editActivity = obj => {
    const id = this.props.match.params.id;
    const formData = this.buildFormData(obj);

    axios
      .post(`${URL.api}pedagogical/follow-ups/${id}/update`, formData, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Content-Type": "multipart/form-data"
        }
      })
      .then(
        resp => {
          if (resp.data.success) {
            toastr.success("Sucesso", resp.data.message);
            this.props.history.push(`/pedagogical-follow-ups/list`);
          } else {
            toastr.error(
              "Erro",
              resp.data.message || "Erro ao atualizar acompanhamento"
            );
            this.setState({ creating: false });
          }
        },
        error => {
          const errorMessage =
            error.response?.data?.message ||
            "Erro ao atualizar acompanhamento pedagógico";
          toastr.error("Erro", errorMessage);
          this.setState({ creating: false });
        }
      );
  };

  render() {
    const { edit, existingPdfUrl, pdfOriginalName, pdfFile } = this.state;
    const hasPdf = (edit && existingPdfUrl) || pdfFile;

    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            {
              path: "/pedagogical-follow-ups/list",
              to: "/pedagogical-follow-ups/list",
              name: "Acompanhamentos Pedagógicos"
            }
          ]}
        />
        {!this.state.loading ? (
          <>
            <CCard>
              <CCardHeader className="d-flex align-items-center">
                <div
                  style={{ display: "flex", flexDirection: "column", flex: 1 }}
                >
                  <h4 className="card-title mb-1">
                    {edit
                      ? "Editar Acompanhamento Pedagógico"
                      : "Criar Acompanhamento Pedagógico"}
                  </h4>
                  <div className="small text-muted">
                    {edit
                      ? "Edite o acompanhamento pedagógico"
                      : "Crie um novo acompanhamento pedagógico"}
                  </div>
                </div>
                <CButton
                  color="primary"
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => this.saveActivity()}
                  disabled={this.state.creating}
                >
                  <>
                    <span style={this.state.creating ? { opacity: 0 } : null}>
                      <i className="fa fa-cloud-upload mr-2"></i>Salvar
                    </span>
                    {this.state.creating && (
                      <CSpinner
                        size="sm"
                        color="white"
                        style={{ position: "absolute" }}
                      />
                    )}
                  </>
                </CButton>
              </CCardHeader>
              <CCardBody>
                <div className="myRow">
                  <FormGroup className="mb3">
                    <CLabel htmlFor="name">
                      Nome do Acompanhamento Pedagógico *
                    </CLabel>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-text-width" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        id="name"
                        type="text"
                        value={this.state.name}
                        onChange={this.changeName}
                        placeholder="Digite o nome do acompanhamento pedagógico"
                        required
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup className="mb3">
                    <CLabel htmlFor="discipline">Disciplina *</CLabel>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-graduation-cap" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        id="discipline"
                        type="select"
                        value={this.state.disciplineId}
                        onChange={this.changeDiscipline}
                        required
                      >
                        <option value="">Selecione uma disciplina</option>
                        {this.state.disciplinesList.map(discipline => (
                          <option key={discipline.id} value={discipline.id}>
                            {discipline.name}
                          </option>
                        ))}
                      </Input>
                    </InputGroup>
                  </FormGroup>

                  <FormGroup className="mb3">
                    <CLabel htmlFor="serie">Série *</CLabel>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-users" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        id="serie"
                        type="select"
                        value={this.state.serieId || ""}
                        onChange={this.changeSerie}
                        required
                      >
                        <option value="">Selecione uma série</option>
                        {this.state.serieList.map(serie => (
                          <option key={serie.id} value={serie.id}>
                            {serie.name}
                          </option>
                        ))}
                      </Input>
                    </InputGroup>
                  </FormGroup>

                  {/* Campo de upload de PDF */}
                  <FormGroup className="mb3">
                    <CLabel htmlFor="pdf">Arquivo PDF (opcional)</CLabel>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fa fa-file-pdf-o" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        id="pdf"
                        type="file"
                        accept="application/pdf"
                        onChange={this.handlePdfChange}
                        innerRef={this.pdfInputRef}
                      />
                    </InputGroup>
                    {hasPdf && (
                      <div className="mt-2">
                        <span className="text-success">
                          <i className="fa fa-check-circle mr-1" />
                          {pdfFile
                            ? `Novo PDF selecionado: ${pdfFile.name}`
                            : `PDF atual: ${pdfOriginalName || "anexado"}`}
                        </span>
                        {edit && existingPdfUrl && !pdfFile && (
                          <a
                            href={existingPdfUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ml-2"
                          >
                            Visualizar
                          </a>
                        )}
                        <CButton
                          color="link"
                          size="sm"
                          className="ml-2 text-danger"
                          onClick={this.removePdf}
                        >
                          Remover
                        </CButton>
                      </div>
                    )}
                    <small className="form-text text-muted">
                      Formatos permitidos: PDF. Tamanho máximo: 20MB.
                    </small>
                  </FormGroup>
                </div>
              </CCardBody>
            </CCard>

            <CCard>
              <CCardHeader>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h4 className="card-title mb-1">Listas de Questões</h4>
                    <div className="small text-muted">
                      Adicione listas de questões ao acompanhamento pedagógico
                    </div>
                  </div>
                  <div>
                    <CButton
                      color="success"
                      size="sm"
                      onClick={this.openQuestionModal}
                      className="mr-2"
                    >
                      <i className="fa fa-plus mr-2"></i>
                      Novo
                    </CButton>
                    <CButton
                      color="info"
                      size="sm"
                      onClick={this.loadAvailableQuestionsList}
                      disabled={this.state.questionsListLoading}
                    >
                      {this.state.questionsListLoading ? (
                        <>
                          <CSpinner size="sm" className="mr-2" />
                          Carregando...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-refresh mr-2"></i>
                          Atualizar
                        </>
                      )}
                    </CButton>
                  </div>
                </div>
              </CCardHeader>
              <CCardBody>
                {/* Listas Selecionadas */}
                {this.state.selectedQuestions.length > 0 && (
                  <div className="mb-4">
                    <h6 className="text-success mb-3">
                      <i className="fa fa-check-circle mr-2"></i>
                      Listas Selecionadas ({this.state.selectedQuestions.length}
                      )
                    </h6>
                    {this.state.selectedQuestions.map(questionList => (
                      <div
                        key={questionList.id}
                        className="border rounded p-3 mb-2 bg-light"
                      >
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="flex-grow-1">
                            <h6 className="mb-2">
                              {questionList.ability_code
                                ? `${questionList.ability_code} - ${
                                    questionList.ability_description ||
                                    questionList.description ||
                                    ""
                                  }`
                                : questionList.description ||
                                  questionList.ability_description ||
                                  "Pergunta sem descrição"}
                            </h6>

                            {questionList.thematic_unit_name && (
                              <div className="mb-2">
                                <span className="badge badge-info mr-2">
                                  {questionList.thematic_unit_name}
                                </span>
                              </div>
                            )}

                            <div className="mt-2">
                              <small className="text-muted d-block mb-2">
                                <strong>Opções de resposta:</strong>
                              </small>
                              <div className="d-flex flex-wrap">
                                {questionList.options &&
                                  questionList.options.map((option, index) => (
                                    <span
                                      key={option.id}
                                      className="badge badge-outline-primary mr-2 mb-1"
                                      style={{
                                        fontSize: "0.75em",
                                        padding: "4px 8px",
                                        border: "1px solid #007bff",
                                        color: "#007bff",
                                        backgroundColor: "transparent"
                                      }}
                                    >
                                      {option.title}
                                    </span>
                                  ))}
                              </div>
                            </div>
                          </div>
                          <CButton
                            color="danger"
                            size="sm"
                            onClick={() =>
                              this.removeQuestionFromList(
                                questionList.item_id || questionList.id
                              )
                            }
                            className="ml-2"
                          >
                            <i className="fa fa-times"></i>
                          </CButton>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Listas Disponíveis */}
                {this.state.questionsListLoading ? (
                  <div className="text-center py-4">
                    <CSpinner className="mb-3" />
                    <p className="text-muted">
                      Carregando listas de questões...
                    </p>
                  </div>
                ) : this.state.availableQuestionsList.length > 0 ? (
                  <div>
                    <h6 className="mb-3">
                      <i className="fa fa-list mr-2"></i>
                      Listas Disponíveis
                    </h6>
                    {this.state.availableQuestionsList.map(questionList => (
                      <div
                        key={questionList.id}
                        className="border rounded p-3 mb-2 bg-white"
                      >
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="flex-grow-1 mr-2">
                            <h6 className="mb-2">
                              {questionList.description ||
                                questionList.ability_description ||
                                "Pergunta sem descrição"}
                            </h6>

                            {questionList.thematic_unit_name && (
                              <div className="mb-2">
                                <span className="badge badge-info mr-2">
                                  {questionList.thematic_unit_name}
                                </span>
                              </div>
                            )}

                            <div className="mt-2">
                              <small className="text-muted d-block mb-2">
                                <strong>Opções de resposta:</strong>
                              </small>
                              <div className="d-flex flex-wrap">
                                {questionList.options &&
                                  questionList.options.map((option, index) => (
                                    <span
                                      key={option.id}
                                      className="badge badge-outline-primary mr-2 mb-1"
                                      style={{
                                        fontSize: "0.75em",
                                        padding: "4px 8px",
                                        border: "1px solid #007bff",
                                        color: "#007bff",
                                        backgroundColor: "transparent"
                                      }}
                                    >
                                      {option.title}
                                    </span>
                                  ))}
                              </div>
                            </div>
                          </div>
                          <CButton
                            color="primary"
                            size="sm"
                            onClick={() => this.addQuestionToList(questionList)}
                            style={{
                              minWidth: "120px",
                              whiteSpace: "nowrap"
                            }}
                          >
                            <i className="fa fa-plus mr-2"></i>
                            Adicionar
                          </CButton>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <i className="fa fa-list-alt fa-3x text-muted mb-3"></i>
                    <p className="text-muted">
                      {this.state.questionsListLoading
                        ? "Carregando listas de questões..."
                        : "Nenhuma lista de questões encontrada. Clique em 'Atualizar' para tentar novamente."}
                    </p>
                  </div>
                )}
              </CCardBody>
            </CCard>
          </>
        ) : (
          <Loading top="45" left="50" />
        )}

        <QuestionModal
          isOpen={this.state.showQuestionModal}
          onClose={this.closeQuestionModal}
          onQuestionCreated={this.handleQuestionCreated}
          user={this.props.user}
        />

        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PedagogicalFollowUpsCreate);
